/**
 *
 *
 *
 *
 *
 *
 */

/**
 *
 */
export const PAGE_CLUSTER = {
    /*                      */
    SEARCH_RESULTS: 'Suchergebnisseite',
    /*                             */
    PRODUCT_LIST: 'Produktliste',
    /*                                       */
    TOPIC_PAGE: 'Themenseite',
} as const;

export type PageCluster = (typeof PAGE_CLUSTER)[keyof typeof PAGE_CLUSTER];

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getPageCluster(): string | undefined {
    if (typeof document === 'undefined') {
        return undefined;
    }
    return document.documentElement.dataset.pagecluster;
}

/**
 *
 */
export function isSearchResultsPage(): boolean {
    return getPageCluster() === PAGE_CLUSTER.SEARCH_RESULTS;
}

/**
 *
 */
export function isProductListPage(): boolean {
    return getPageCluster() === PAGE_CLUSTER.PRODUCT_LIST;
}

/**
 *
 */
export function isTopicPage(): boolean {
    return getPageCluster() === PAGE_CLUSTER.TOPIC_PAGE;
}

/**
 *
 *
 */
export function isSearchOrProductListPage(): boolean {
    const cluster = getPageCluster();
    return cluster === PAGE_CLUSTER.SEARCH_RESULTS || cluster === PAGE_CLUSTER.PRODUCT_LIST;
}
